import Vue from 'vue';
import { DialogOptions, DialogState } from './types';

const state = Vue.observable<DialogState>({
  component: null,
  props: {},
  show: false,
});

export function displayDialog(dialogOptions: DialogOptions) {
  state.component = dialogOptions.component;
  state.props = dialogOptions.props || {};
  state.show = true;
}

export function dismissDialog() {
  state.component = null;
  state.props = {};
  state.show = false;
}

export function getDialogComponent() {
  return state.component;
}

export function getDialogProps() {
  return state.props;
}

export function isDialogVisible() {
  return state.show;
}
